import {FC, useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router'
import {SettingsSidebarId} from 'pages/settings/config'
import {names} from 'shared/lib'
import {ArrowLeft} from 'shared/ui/icons'
import {Modal} from 'shared/ui/modal'
import {BottomMenu} from 'widgets/bottomMenu'
import {ContentMobile} from '../contentMobile'
import {SettingsSidebar} from '../settingsSidebar'
import styles from './styles.module.scss'

export const SettingsMobile: FC = () => {
  const navigate = useNavigate()
  const popupRef = useRef<HTMLDivElement>(null)
  const [selectedId, setSelectedId] = useState<SettingsSidebarId | undefined>(
    undefined
  )
  const [isMounted, setIsMounted] = useState(false)

  const onCloseHandler = () => {
    const historyState = window.history.state

    if (popupRef.current) {
      popupRef.current.style.left = '100%'
    }

    setTimeout(() => {
      if (historyState && historyState.idx > 0) {
        return navigate(-1)
      }
      navigate('/', {replace: true})
    }, Number(styles.animateCloseModalTimeMs))
  }

  const onCloseContentHandler = () => {
    setSelectedId(undefined)
  }

  useEffect(() => {
    if (!isMounted) return setIsMounted(true)

    if (popupRef.current) {
      popupRef.current.style.left = '0'
    }

  }, [isMounted])

  return (
    <>
      <Modal
        disableEnforceFocus
        open
        classes={{backdrop: styles.modalBackdrop}}
      >
        <div className={styles.wrapperMobileSettings}>
          <div className={styles.mobileSettings} ref={popupRef}>
            <div className={styles.header}>
              <div className={styles.backBtn} onClick={onCloseHandler}>
                <ArrowLeft />
              </div>
              <h2 className={styles.headerTitle}>Settings</h2>
            </div>
            <div className={names(styles.content, styles.customScroll)}>
              <SettingsSidebar onClickItem={setSelectedId} />
            </div>
            <BottomMenu />
          </div>
        </div>

      </Modal>
      <ContentMobile selectedId={selectedId} onClose={onCloseContentHandler} />
    </>
  )
}
